import { CodeEditor, FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';
import { getConditionalSeverityString } from 'testManagement/utils/utils';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const YamlTestConfig = ({ watch }: Props) => {
  const { warnIf, errorIf } = getConditionalSeverityString(watch('severity'));

  return (
    <>
      <CodeEditor
        value={watch('yaml')}
        mode="yaml"
        height="250px"
        fontSize={14}
        readOnly
      />

      <SeverityRenderer
        severity={watch('severity')?.type || 'error'}
        warnIf={warnIf}
        errorIf={errorIf}
      />

      {watch('limit') && (
        <FormControls.FormText>
          Limit: <b>{watch('limit')}</b>
        </FormControls.FormText>
      )}

      {watch('shouldStoreFailures') && (
        <FormControls.FormText>
          Store failure data: <b>True</b>
        </FormControls.FormText>
      )}
    </>
  );
};

export default YamlTestConfig;
